'use client';

import React, { useEffect, useState } from 'react';
import DeploymentToasts from '../DeploymentTooltip/DeploymentTooltip';
import { sha256 } from '@/src/lib/hash';
import { usePathname } from 'next/navigation';
import Cookies from 'js-cookie';

export function ClientWrapper() {
    const pathname = usePathname();

    useEffect(() => {
        const checkDeploy = async () => {
            const raw = Cookies.get('waiting-for-deploy');
            if (!raw) return;

            let parsed;
            try {
                parsed = JSON.parse(raw);
            } catch (e) {
                console.warn('Invalid cookie format for waiting-for-deploy');
                Cookies.remove('waiting-for-deploy');
                return;
            }

            const { locale, contentHash } = parsed;
            if (!locale || !contentHash) return;

            try {
                const mod = await import(`@/src/dictionaries/${locale}.json`);
                const deployedDict = mod.default;
                const deployedHash = await sha256(deployedDict);

                if (deployedHash === contentHash) {
                    Cookies.remove('waiting-for-deploy');
                    location.reload();
                }
            } catch (err) {
                console.error('⚠️ Failed to check deployed dictionary:', err);
            }
        };

        checkDeploy();

        const handleEvent = () => checkDeploy();
        window.addEventListener('waiting-for-deploy', handleEvent);

        const timeout = setTimeout(() => {
            console.warn('⏰ Timeout reached: removing block.');
            Cookies.remove('waiting-for-deploy');
        }, 120_000); // 2 minutes max

        return () => {
            window.removeEventListener('waiting-for-deploy', handleEvent);
            clearTimeout(timeout);
        };
    }, [pathname]);

    return (
        <>
            <DeploymentToasts />
        </>
    );
}
